import type { AuthUser, LoginInput } from '@boodschappenlijst/shared';
import { api } from '../../lib/apiClient';

export const authApi = {
  me: () => api.get<{ user: AuthUser | null }>('/auth/me'),
  login: (input: LoginInput) => api.post<{ user: AuthUser }>('/auth/login', input),
  logout: () => api.post<{ ok: true }>('/auth/logout'),
};
